import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";

export const useFileUploadClient = () => {
  const { mutateAsync: uploadMutation, isLoading } = useMutation(["/api/raw/attachments/upload"], async (file: File) => {
    try {
      const fileNameParts = file.name.split(".");
      let extension = "";
      if (fileNameParts.length > 1) {
        extension = fileNameParts.pop()!;
      }
      const fileName = uuidv4() + "." + extension;
      const formData = new FormData();
      formData.append("file", file, fileName);
      const response = await fetch("/api/raw/attachments/upload", {
        method: "POST",
        body: formData,
      });
      if (response.status >= 400) {
        throw new Error("Unknown file upload error occurred");
      }
      return await response.json();
    } catch (e: any) {
      toast.error(`Failed to upload file: ${e.message}`);
      throw e;
    }
  });

  return { uploadFile: (file: File) => uploadMutation(file), isLoading };
};
